import {
  bloodTypeOptions,
  doctorSpecializationOptions,
  userTypeOptions,
} from "./choices";
import {
  civilStatusOptions,
  genderOptions,
  roleOptions,
} from "./formFieldPresets";

// Columns used in the table list
export const userTableColumns = [
  { key: "fullname", name: "fullname", label: "Name" },
  { key: "email", name: "email", label: "Email" },
  {
    key: "phone_number",
    name: "phone_number",
    label: "Phone",
    type: "number",
  },

  {
    key: "role",
    name: "role",
    label: "Role",
    type: "select",
    options: roleOptions,
  },
  {
    key: "user_type",
    name: "user_type",
    label: "User Type",
    options: userTypeOptions,
    type: "select",
  },
  { key: "created_on", name: "created_on", label: "Created", type: "date" },
];

export const userSettings = [
  { label: "First Name", name: "first_name", required: true },
  { label: "Last Name", name: "last_name", required: true },
  { label: "Middle Initial", name: "middle_initial" },
  { label: "Suffix", name: "suffix" },
  { label: "Phone Number", name: "phone_number", required: true },
  { label: "Email Address", name: "email", type: "email", required: true },
  {
    label: "Date of Birth",
    name: "date_of_birth",
    type: "date",
    required: true,
  },
  { label: "Address", name: "address", type: "textarea", required: true },
  { label: "About me", name: "bio", type: "textarea", required: true },
  // {
  //   name: "specialization",
  //   label: "Specialization",
  //   options: doctorSpecializationOptions,
  //   condition: "doctor",
  //   type: "multiselect",
  //   required: true,
  // },
  // {
  //   name: "license",
  //   label: "License",
  //   condition: "doctor",
  //   required: true,
  //   type: "text",
  // },
  // { label: "Password", name: "password", type: "password" },
];

// Form field definitions with conditional visibility
// showOn: 'create' | 'edit' | 'view' | 'all'
export const userFormFields = [
  {
    name: "first_name",
    label: "First Name",
    showOn: "all",
    required: true,
    type: "text",
  },
  {
    name: "last_name",
    label: "Last Name",
    showOn: "all",
    required: true,
    type: "text",
  },
  {
    name: "middle_initial",
    label: "Middle Initial",
    showOn: "all",
    type: "text",
  },
  {
    name: "suffix",
    label: "Suffix",
    showOn: "all",
    type: "text",
  },
  // { type: "half-spacer", showOn: "create" },
  {
    name: "email",
    label: "Email",
    type: "email",
    showOn: "all",
    required: true,
  },
  {
    name: "date_of_birth",
    label: "Date of Birth",
    type: "date",
    showOn: "all",
    required: true,
  },
  // {
  //   name: "password",
  //   label: "Password",
  //   type: "password",
  //   showOn: "create",
  //   required: true,
  // },
  {
    name: "phone_number",
    label: "Phone",
    type: "tel",
    showOn: "all",
    required: true,
  },

  {
    name: "gender",
    label: "Gender",
    type: "select",
    options: genderOptions,
    showOn: "all",
    required: true,
  },
  {
    name: "civil_status",
    label: "Civil Status",
    type: "select",
    options: civilStatusOptions,
    showOn: "all",
    required: true,
  },
  {
    name: "blood_type",
    label: "Blood Type",
    options: bloodTypeOptions,
    type: "select",
    showOn: "all",
    required: true,
  },

  { type: "spacer", showOn: "all" },
  {
    name: "address",
    label: "Address",
    type: "textarea",
    showOn: "all",
    required: true,
  },
  {
    name: "occupation",
    label: "Occupation",
    showOn: "all",
    required: true,
    type: "text",
  },
  { type: "spacer", showOn: "all" },
  {
    name: "role",
    label: "Role",
    type: "select",
    options: roleOptions,
    showOn: "edit,view",
  },
  {
    name: "user_type",
    label: "User Type",
    options: userTypeOptions,
    type: "select",
    default: "external",
    showOn: "edit,view",
    required: true,
  },
  // {
  //   name: "specialization",
  //   label: "Specialization",
  //   options: doctorSpecializationOptions,
  //   condition: "doctor",
  //   type: "multiselect",
  //   showOn: "all",
  //   required: true,
  // },
  // {
  //   name: "license",
  //   label: "License",
  //   condition: "doctor",
  //   showOn: "all",
  //   required: true,
  //   type: "text",
  // },
  { type: "spacer", showOn: "all" },
  { name: "avatar", label: "Avatar", type: "file", showOn: "all" },
];
